// @flow

const FlattenStyle = (style: any) => style;
export { FlattenStyle };
